import { render } from "./ModalSearch.vue?vue&type=template&id=65a2a332&scoped=true"
import script from "./ModalSearch.vue?vue&type=script&lang=js"
export * from "./ModalSearch.vue?vue&type=script&lang=js"

import "./ModalSearch.vue?vue&type=style&index=0&id=65a2a332&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a2a332"]])

export default __exports__